import { useState } from 'react';
import { Panel } from '../../../../components/panels/Panel';
import { usePatternSetup } from '../../../../contexts/PatternSetupContext';
import { useAlert } from '../../../../contexts/AlertContext';
import { deleteData, removeItemFromCache } from '../../../../services/api/api-tools';
import { WarnModal } from '../pattern-panel/WarnModal';
import { JournalPatternList } from './JournalPatternList';
import { useQueryClient } from 'react-query';
import { useSocket } from '../../../../contexts/SocketContext';

export const JournalLeftPanel = () => {
  const { showAlert } = useAlert();
  const { setIsPatternPanelOpened, patternId, cleanEditingPattern, patternsQueryKey } = usePatternSetup();
  const { sendEvent } = useSocket();

  const [isWarnModalOpen, setIsWarnModalOpen] = useState(false);
  const [patternIdToDelete, setPatternIdToDelete] = useState(null);

  const queryClient = useQueryClient();

  const onConfirmDelete = async (patternIdToDelete) => {
    try {
      await deleteData('patterns', patternIdToDelete);
      showAlert('success', 'The pattern has been successfully deleted from the database. ');
      removeItemFromCache(queryClient, patternsQueryKey, (pattern) => pattern.id === patternIdToDelete);
      sendEvent('ihm_update_patterns');
      if (patternId === patternIdToDelete) {
        cleanEditingPattern();
        setIsPatternPanelOpened(false);
      }
    } catch (err) {
      console.error('Something bad happened:', err);
      showAlert('warning', 'Oops! We encountered an issue while attempting to delete the pattern.');
    } finally {
      setIsWarnModalOpen(false);
      setPatternIdToDelete(null);
    }
  };

  return (
    <>
      <Panel title="PATTERNS">
        <JournalPatternList setIsWarnModalOpen={setIsWarnModalOpen} setPatternIdToDelete={setPatternIdToDelete} />
      </Panel>

      <WarnModal
        isOpen={isWarnModalOpen}
        setIsWarnModalOpen={setIsWarnModalOpen}
        onConfirmDelete={() => onConfirmDelete(patternIdToDelete)}
      />
    </>
  );
};
